import React, { useContext, useEffect, useRef } from "react";

// SASS
import "./Part1.scss";

// COMPONENTS
import Step from "../Step/Step";

// CONTEXT
import BuildContext from "../../contexts/BuildContext/BuildContext";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import hallwayBackgroundImg from "../../assets/img/office-hallway-background.png";
import nurseImg from "../../assets/img/nurse-1.png";
import nurseHandsImg from "../../assets/img/nurse-1-glowing-hands.png";

export default function Part1({ step }) {
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    {
      stepNumber: "1",
      height: null,
      description: "fade in blue text box and man",
    },
    {
      stepNumber: "2",
      height: null,
      description: "fade out background and show eyes text",
    },
    { stepNumber: "3", height: null, description: "show nose text" },
    { stepNumber: "4", height: null, description: "show mouth text" },
    { stepNumber: "5", height: null, description: "show mouth text block" },
    {
      stepNumber: "6",
      height: null,
      description: "show hands text block and hands img",
    },
    { stepNumber: "7", height: null, description: "spacer" },
  ];

  const scrolly = scrollama();

  const sceneBackgroundEl = useRef(null);
  const blueTextBlockEl = useRef(null);
  const nurseEl = useRef(null);
  const nurseHandsEl = useRef(null);
  const noseTextEl = useRef(null);
  const eyesTextEl = useRef(null);
  const mouthTextEl = useRef(null);
  const handsTextBlockEl = useRef(null);

  const { buildEnv } = useContext(BuildContext);

  useEffect(() => {
    scrolly
      .setup({
        step: ".step",
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ index, direction }) => {
        switch (index) {
          case 1: {
            // animate.fadeInOnEnter(blueTextBlockEl.current, direction);
            // animate.fadeInOnEnter(nurseEl.current, direction);
            break;
          }
          case 2: {
            animate.addClassOnEnter(
              sceneBackgroundEl.current,
              "faded",
              direction
            );
            animate.fadeInOnEnter(eyesTextEl.current, direction);
            break;
          }
          case 3: {
            animate.fadeInOnEnter(noseTextEl.current, direction);
            break;
          }
          case 4: {
            animate.fadeInOnEnter(mouthTextEl.current, direction);
            break;
          }
          case 5: {
            animate.fadeInOnEnter(nurseHandsEl.current, direction);
            animate.fadeInOnEnter(handsTextBlockEl.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ index, progress }) => {
        switch (index) {
          default:
            break;
        }
      })
      .onStepExit(({ index, direction }) => {
        switch (index) {
          case 1: {
            // animate.fadeOutOnExit(blueTextBlockEl.current, direction);
            // animate.fadeOutOnExit(nurseEl.current, direction);
            break;
          }
          case 2: {
            animate.removeClassOnExit(
              sceneBackgroundEl.current,
              "faded",
              direction
            );
            animate.fadeOutOnExit(eyesTextEl.current, direction);
            break;
          }
          case 3: {
            animate.fadeOutOnExit(noseTextEl.current, direction);
            break;
          }
          case 4: {
            animate.fadeOutOnExit(mouthTextEl.current, direction);
            break;
          }
          case 5: {
            animate.fadeOutOnExit(nurseHandsEl.current, direction);
            animate.fadeOutOnExit(handsTextBlockEl.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly]);

  const showStepText = (buildEnv, text) => {
    if (buildEnv === "development") {
      return text;
    } else return null;
  };

  return (
    <section className="wrapper one">
      <div className="sticky-container--full">
        {/* Sticky contents in here */}
        <div className="part1">
          {/* <p className="text">hello world</p> */}
          <div className="scene-background" ref={sceneBackgroundEl}>
            <img
              className="img-fluid"
              src={hallwayBackgroundImg}
              alt="hallway"
            />
          </div>
          <div className="blue-text-block" ref={blueTextBlockEl}>
            We get sick when viruses enter our
          </div>
          <div className="nurse-img" ref={nurseEl}>
            <img src={nurseImg} alt="Nurse" className="img-fluid" />
          </div>
          <div className="nurse-img nurse-img-hands" ref={nurseHandsEl}>
            <img src={nurseHandsImg} alt="Nurse" className="img-fluid" />
          </div>
          <div className="outline-text outline-text__nose" ref={noseTextEl}>
            Nose
          </div>
          <div className="outline-text outline-text__eyes" ref={eyesTextEl}>
            Eyes
          </div>
          <div className="outline-text outline-text__mouth" ref={mouthTextEl}>
            Mouth
          </div>
          <div className="hands-text-block" ref={handsTextBlockEl}>
            OR ON OUR HANDS
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
